export default __webpack_public_path__ + "static/media/home-banner-3.96bf9894.gif";